(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__contentMediaLogoSwiperBooted) return;
    window.__contentMediaLogoSwiperBooted = true;

    const mobileQuery = window.matchMedia('(max-width: 47.99rem)');
    const instances = new Set();

    const destroy = (root) => {
      const state = root.__contentMediaLogoSwiper;
      if (!state) return;

      state.focusHandler && root.removeEventListener('focusin', state.focusHandler);
      state.resizeHandler && window.removeEventListener('resize', state.resizeHandler);
      state.animationFrame && window.cancelAnimationFrame(state.animationFrame);
      state.clones?.forEach((clone) => clone.remove());
      state.swiper?.destroy(true, true);
      root.__contentMediaLogoSwiper = null;
      instances.delete(root);
    };

    const mount = (root) => {
      if (!(root instanceof HTMLElement)) return;

      const slideCount = root.querySelectorAll('.swiper-slide').length;
      if (!mobileQuery.matches || typeof window.Swiper !== 'function' || slideCount < 2) {
        destroy(root);
        return;
      }

      if (root.__contentMediaLogoSwiper) return;

      const wrapper = root.querySelector('.swiper-wrapper');
      const originalSlides = Array.from(wrapper?.children || []);
      if (!wrapper || originalSlides.length < 2) {
        destroy(root);
        return;
      }

      const clones = originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('img').forEach((image) => {
          image.loading = 'eager';
          image.decoding = 'async';
        });
        return clone;
      });
      clones.forEach((clone) => wrapper.appendChild(clone));

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const swiper = new window.Swiper(root, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        allowTouchMove: false,
      });

      const state = {
        swiper,
        clones,
        offset: 0,
        loopWidth: 0,
        lastTime: 0,
        speed: reduceMotion ? 0 : 60,
        paused: false,
        animationFrame: 0,
      };
      const updateLoopWidth = () => {
        state.loopWidth = clones[0]?.offsetLeft - originalSlides[0]?.offsetLeft || wrapper.scrollWidth / 2;
        if (state.loopWidth > 0) state.offset %= state.loopWidth;
        wrapper.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
      };
      const focusHandler = () => {
        state.paused = true;
      };
      const resizeHandler = () => updateLoopWidth();
      const animate = (timestamp) => {
        if (!state.lastTime) state.lastTime = timestamp;
        const elapsed = Math.min(timestamp - state.lastTime, 50);
        state.lastTime = timestamp;

        if (!state.paused && state.loopWidth > 0) {
          state.offset += (state.speed * elapsed) / 1000;
          if (state.offset >= state.loopWidth) state.offset %= state.loopWidth;
          wrapper.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
        }

        state.animationFrame = window.requestAnimationFrame(animate);
      };

      state.focusHandler = focusHandler;
      state.resizeHandler = resizeHandler;
      root.__contentMediaLogoSwiper = state;
      root.addEventListener('focusin', focusHandler);
      window.addEventListener('resize', resizeHandler);
      instances.add(root);
      updateLoopWidth();
      state.animationFrame = window.requestAnimationFrame(animate);
    };

    const scan = (scope) => {
      if (!scope || typeof scope.querySelectorAll !== 'function') return;
      scope.querySelectorAll('[data-logo-swiper]').forEach(mount);
    };

    let bootFrames = 0;
    const boot = () => {
      scan(document);
      bootFrames += 1;
      if (typeof window.Swiper !== 'function' && bootFrames < 240) {
        window.requestAnimationFrame(boot);
      }
    };

    const handleBreakpoint = () => {
      instances.forEach((root) => {
        if (!mobileQuery.matches) destroy(root);
      });
      scan(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    mobileQuery.addEventListener('change', handleBreakpoint);

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-logo-swiper]').forEach(destroy);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const submitCollectionForm = (form) => {
  form.querySelectorAll('input[type="number"]').forEach((input) => {
    if (input.value.trim() === '') input.disabled = true;
  });
  form.requestSubmit();
};

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.collection__filter')) return;
  details.parentElement?.querySelectorAll('.collection__filter[open]').forEach((other) => {
    if (other !== details) other.open = false;
  });
}, true);

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement) || !target.matches('[data-collection-sort]')) return;
  if (target.form) submitCollectionForm(target.form);
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.collection__form')) return;
  form.querySelectorAll('input[type="number"]').forEach((input) => {
    if (input.value.trim() === '') input.disabled = true;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-main')) {
    class ProductMain extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const start = () => {
          if (!this.isConnected) return;
          this.bind();
          this.waitForSwiper();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true });
        } else {
          window.requestAnimationFrame(start);
        }
      }

      disconnectedCallback() {
        this.ready = false;
        window.clearInterval(this.waitTimer);
        this.variantSelect?.removeEventListener('change', this.onVariantChange);
        this.form?.removeEventListener('submit', this.onSubmit);
        this.quantityInput?.removeEventListener('input', this.onQuantityInput);
        this.quantityInput?.removeEventListener('change', this.onQuantityInput);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('click', this.onClick, true);
        this.removeEventListener('keydown', this.onKeydown);
        this.zoomDialog?.removeEventListener('close', this.onZoomClose);
        this.zoomDialog?.removeEventListener('keydown', this.onZoomKeydown);
        this.destroySwipers();
      }

      bind() {
        this.variants = this.readVariants();
        this.variantSelect = this.querySelector('[data-variant-select]');
        this.quantityInput = this.querySelector('[data-quantity]');
        this.zoomDialog = this.querySelector('[data-zoom-dialog]');
        this.zoomImage = this.querySelector('[data-zoom-image]');
        this.zoomClose = this.querySelector('[data-zoom-close]');
        this.gallery = this.querySelector('.product-main__gallery');
        this.form = this.querySelector('.product-main__form');
        this.variantSelect?.addEventListener('change', this.onVariantChange);
        this.form?.addEventListener('submit', this.onSubmit);
        this.quantityInput?.addEventListener('input', this.onQuantityInput);
        this.quantityInput?.addEventListener('change', this.onQuantityInput);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('click', this.onClick, true);
        this.addEventListener('keydown', this.onKeydown);
        this.zoomDialog?.addEventListener('close', this.onZoomClose);
        this.zoomDialog?.addEventListener('keydown', this.onZoomKeydown);
        this.syncQuantity();
      }

      readVariants() {
        const node = this.querySelector('[data-product-variants]');
        if (!node) return [];
        try {
          const parsed = JSON.parse(node.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      waitForSwiper() {
        if (typeof window.Swiper === 'function') {
          this.mount();
          return;
        }
        let attempts = 0;
        this.waitTimer = window.setInterval(() => {
          attempts += 1;
          if (!this.isConnected || attempts > 100) {
            window.clearInterval(this.waitTimer);
            return;
          }
          if (typeof window.Swiper === 'function') {
            window.clearInterval(this.waitTimer);
            this.mount();
          }
        }, 40);
      }

      measureGap() {
        const probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:0.625rem;';
        this.appendChild(probe);
        const width = probe.getBoundingClientRect().width;
        probe.remove();
        return Number.isFinite(width) && width > 0 ? width : 10;
      }

      mount() {
        if (this.mainSwiper || !this.isConnected || typeof window.Swiper !== 'function') return;
        const mainEl = this.querySelector('[data-product-main]');
        if (!mainEl) return;

        const slides = Array.from(mainEl.querySelectorAll('.swiper-slide'));
        if (!slides.length) return;

        const initialId = this.dataset.initialMediaId || '';
        let initial = slides.findIndex((slide) => slide.dataset.mediaId === initialId);
        if (initial < 0) initial = 0;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const gap = this.measureGap();
        const thumbEl = this.querySelector('[data-product-thumbs]');

        if (thumbEl && thumbEl.querySelectorAll('.swiper-slide').length > 1) {
          this.thumbSwiper = new window.Swiper(thumbEl, {
            slidesPerView: 'auto',
            spaceBetween: gap,
            initialSlide: initial,
            watchSlidesProgress: true,
            watchOverflow: true,
            slideToClickedSlide: false,
            observer: true,
            observeParents: true,
            freeMode: {
              enabled: true,
            },
            speed: reduceMotion ? 0 : 300,
            a11y: {
              enabled: true,
            },
          });
        }

        this.mainSwiper = new window.Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: initial,
          speed: reduceMotion ? 0 : 300,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          preventClicks: false,
          preventClicksPropagation: false,
          keyboard: {
            enabled: false,
          },
          a11y: {
            enabled: true,
            prevSlideMessage: this.dataset.prevLabel || 'Previous image',
            nextSlideMessage: this.dataset.nextLabel || 'Next image',
          },
          thumbs: this.thumbSwiper ? { swiper: this.thumbSwiper } : undefined,
        });

        this.mainSwiper.on('slideChange', this.onSlideChange);
        this.querySelectorAll('.product-main__thumbs .is-active').forEach((slide) => {
          slide.classList.remove('is-active');
        });
        this.syncThumbs();
        mainEl.querySelectorAll('img').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', () => this.mainSwiper?.update(), { once: true });
          }
        });
      }

      destroySwipers() {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbSwiper) {
          this.thumbSwiper.destroy(true, true);
          this.thumbSwiper = null;
        }
      }

      activeSlide() {
        if (!this.mainSwiper) return null;
        return this.mainSwiper.slides[this.mainSwiper.activeIndex] || null;
      }

      syncThumbs() {
        const activeId = this.activeSlide()?.dataset.mediaId;
        this.querySelectorAll('.product-main__thumb').forEach((button) => {
          const id = button.closest('.swiper-slide')?.dataset.mediaId;
          button.setAttribute('aria-current', id === activeId ? 'true' : 'false');
        });
        const zoomButton = this.querySelector('.product-main__zoom-button');
        if (zoomButton) zoomButton.hidden = !this.activeSlide()?.dataset.zoomSrc;
      }

      onSlideChange = () => {
        this.syncThumbs();
        if (this.zoomDialog?.open) this.fillZoom(this.activeSlide());
      };

      goToMedia(mediaId) {
        if (!this.mainSwiper || mediaId == null) return;
        const id = String(mediaId);
        const index = Array.from(this.mainSwiper.slides).findIndex((slide) => slide.dataset.mediaId === id);
        if (index < 0) return;
        if (index === this.mainSwiper.activeIndex) {
          this.syncThumbs();
          return;
        }
        this.mainSwiper.slideTo(index);
      }

      onVariantChange = () => {
        if (!this.variantSelect) return;
        const id = Number(this.variantSelect.value);
        const variant = this.variants.find((item) => item.id === id);
        if (!variant) return;
        this.applyVariant(variant);
      };

      applyVariant(variant) {
        const variantInput = this.form?.querySelector('[data-variant-id]');
        if (variantInput instanceof HTMLInputElement && variantInput.value !== String(variant.id)) {
          variantInput.value = String(variant.id);
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const price = this.querySelector('[data-price-current]');
        const compare = this.querySelector('[data-price-compare]');
        const button = this.querySelector('[data-add-button]');
        if (price) price.textContent = variant.price || '';
        if (compare) {
          if (variant.compare_at_price) {
            compare.hidden = false;
            compare.textContent = variant.compare_at_price;
          } else {
            compare.hidden = true;
            compare.textContent = '';
          }
        }
        if (button) {
          const available = Boolean(variant.available);
          button.disabled = !available;
          button.textContent = available ? this.dataset.addLabel || '' : this.dataset.soldLabel || '';
        }
        if (variant.featured_media_id) this.goToMedia(variant.featured_media_id);
        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url);
        }
      }

      onQuantityInput = () => {
        if (!this.quantityInput) return;
        if (this.quantityInput.value !== '') {
          const value = Number.parseInt(this.quantityInput.value, 10);
          if (!Number.isFinite(value) || value < 1) this.quantityInput.value = '1';
        }
        this.syncQuantity();
      };

      syncQuantity() {
        if (!this.quantityInput) return;
        const value = Number.parseInt(this.quantityInput.value, 10);
        const decrease = this.querySelector('[data-qty-step="-1"]');
        if (decrease) decrease.disabled = !Number.isFinite(value) || value <= 1;
      }

      onPointerDown = (event) => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
      };

      onClick = (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !this.contains(target)) return;

        const step = target.closest('[data-qty-step]');
        if (step instanceof HTMLButtonElement && this.quantityInput) {
          const current = Number.parseInt(this.quantityInput.value, 10);
          const next = (Number.isFinite(current) ? current : 1) + Number(step.dataset.qtyStep);
          this.quantityInput.value = String(Math.max(1, next));
          this.syncQuantity();
          return;
        }

        if (target.closest('[data-zoom-close]')) {
          this.zoomDialog?.close();
          return;
        }

        if (target === this.zoomDialog) {
          this.zoomDialog.close();
          return;
        }

        const zoom = target.closest('[data-zoom-open]');
        if (!zoom || !this.contains(zoom)) return;
        if (this.pointerStart) {
          const dx = Math.abs(event.clientX - this.pointerStart.x);
          const dy = Math.abs(event.clientY - this.pointerStart.y);
          if (dx > 10 || dy > 10) return;
        }
        event.preventDefault();
        this.openZoom();
      };

      onSubmit = (event) => {
        if (!this.form) return;
        if (this.variantSelect) {
          const variantInput = this.form.querySelector('[data-variant-id]');
          if (variantInput instanceof HTMLInputElement) variantInput.value = this.variantSelect.value;
        }
        const id = Number(new FormData(this.form).get('id'));
        const variant = this.variants.find((item) => item.id === id);
        if (!variant || variant.available) return;
        event.preventDefault();
        event.stopPropagation();
      };

      onZoomKeydown = (event) => {
        if (event.key !== 'Escape' || !this.zoomDialog?.open) return;
        event.preventDefault();
        this.zoomDialog.close();
      };

      onKeydown = (event) => {
        if (event.key === 'Escape') {
          if (this.zoomDialog?.open) this.zoomDialog.close();
          return;
        }
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.product-main__info') || this.zoomDialog?.open) {
          event.stopPropagation();
        }
        if (!this.gallery || !this.gallery.contains(event.target) || !this.mainSwiper) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.mainSwiper.slideNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.mainSwiper.slidePrev();
        }
      };

      openZoom() {
        const slide = this.activeSlide();
        if (!slide || !this.zoomDialog || !this.fillZoom(slide)) return;
        const active = document.activeElement;
        const trigger = slide.querySelector('[data-zoom-open]');
        this.lastFocus =
          active instanceof HTMLElement && this.contains(active) && !this.zoomDialog.contains(active)
            ? active
            : trigger;
        if (!this.zoomDialog.open) this.zoomDialog.showModal();
        this.zoomClose?.focus();
      }

      fillZoom(slide) {
        if (!slide || !this.zoomImage || !slide.dataset.zoomSrc) return false;
        const width = Number(slide.dataset.zoomWidth);
        const height = Number(slide.dataset.zoomHeight);
        if (width > 0) this.zoomImage.width = width;
        if (height > 0) this.zoomImage.height = height;
        this.zoomImage.alt = slide.dataset.zoomAlt || '';
        if (this.zoomImage.getAttribute('src') !== slide.dataset.zoomSrc) {
          this.zoomImage.src = slide.dataset.zoomSrc;
        }
        return true;
      }

      onZoomClose = () => {
        if (this.lastFocus && this.contains(this.lastFocus)) this.lastFocus.focus();
      };
    }

    customElements.define('product-main', ProductMain);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  const opaqueBackground = (element) => {
    const color = getComputedStyle(element).backgroundColor;
    if (!color || color === 'transparent') return null;
    const parts = color.match(/[\d.]+/g);
    if (parts && parts.length === 4 && Number(parts[3]) === 0) return null;
    return color;
  };

  const sectionBackground = (section) => {
    const nodes = [section, ...section.children];
    for (const node of nodes) {
      const color = opaqueBackground(node);
      if (color) return color;
    }
    return null;
  };

  const previousBackground = (newsletter) => {
    let node = newsletter.closest('.shopify-section');

    while (node && node !== document.body) {
      let sibling = node.previousElementSibling;

      while (sibling) {
        const sections = sibling.classList.contains('shopify-section')
          ? [sibling]
          : [...sibling.querySelectorAll('.shopify-section')].reverse();

        for (const section of sections) {
          if (section.getBoundingClientRect().height < 8) continue;
          const color = sectionBackground(section);
          if (color) return color;
        }

        sibling = sibling.previousElementSibling;
      }

      node = node.parentElement;
    }

    return null;
  };

  const paintNewsletter = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.newsletter').forEach((newsletter) => {
      const color = previousBackground(newsletter);
      if (color) newsletter.style.setProperty('--newsletter-top', color);
    });
  };

  const schedulePaint = () => {
    window.cancelAnimationFrame(window.__newsletterPaintFrame);
    window.__newsletterPaintFrame = window.requestAnimationFrame(() => paintNewsletter(document));
  };

  schedulePaint();

  if (!window.__newsletterPaintBound) {
    window.__newsletterPaintBound = true;
    document.addEventListener('shopify:section:load', schedulePaint);
    const main = document.querySelector('#MainContent');
    if (main) {
      new MutationObserver(schedulePaint).observe(main, { childList: true, subtree: true });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-faq')) {
    class ProductFaq extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.items = [...this.querySelectorAll('[data-faq-item]')];
        this.items.forEach((item) => {
          item.querySelector('[data-faq-trigger]')?.addEventListener('click', () => this.toggle(item));
        });
      }

      toggle(item) {
        const isOpen = item.classList.contains('is-open');
        const current = this.items.find((candidate) => candidate.classList.contains('is-open'));
        if (current && current !== item) this.animate(current, false);
        this.animate(item, !isOpen);
      }

      animate(item, open) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const answer = item.querySelector('[data-faq-answer]');
        if (!trigger || !answer) return;

        trigger.setAttribute('aria-expanded', String(open));
        answer.setAttribute('aria-hidden', String(!open));
        item.classList.toggle('is-open', open);

        const targetHeight = open ? answer.scrollHeight : 0;
        const gsap = window.gsap;
        if (!gsap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          answer.style.height = open ? 'auto' : '0px';
          answer.style.opacity = open ? '1' : '0';
          return;
        }

        gsap.killTweensOf(answer);
        if (open) answer.style.height = '0px';
        gsap.to(answer, {
          height: targetHeight,
          opacity: open ? 1 : 0,
          duration: 0.45,
          ease: 'power3.inOut',
          overwrite: 'auto',
          onComplete: () => {
            if (open) answer.style.height = 'auto';
          },
        });
      }
    }

    customElements.define('product-faq', ProductFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-order')) {
    class ProductOrder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        const configNode = this.querySelector('[data-order-config]');
        try {
          this.config = JSON.parse(configNode ? configNode.textContent || '{}' : '{}');
        } catch (error) {
          this.config = {};
        }

        this.pending = new Map();
        this.flushing = false;
        this.queued = false;
        this.onCart = (event) => this.applyCart(event.detail);
        document.addEventListener('theme:cart', this.onCart);
        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('input', (event) => this.onInput(event));
        this.addEventListener('change', (event) => this.onChange(event));
      }

      disconnectedCallback() {
        if (this.onCart) document.removeEventListener('theme:cart', this.onCart);
        this.dataset.bound = 'false';
      }

      onClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const delta = target.closest('[data-order-delta]');
        if (delta instanceof HTMLButtonElement) {
          const row = delta.closest('[data-variant-id]');
          if (!(row instanceof HTMLElement) || row.dataset.available === 'false') return;
          const input = row.querySelector('[data-order-qty]');
          if (!(input instanceof HTMLInputElement) || input.disabled) return;
          const current = Number.parseInt(input.value, 10);
          const next = this.clamp(input, (Number.isFinite(current) ? current : 0) + Number(delta.dataset.orderDelta));
          input.value = String(next);
          this.commit(row, next);
          return;
        }

        if (target.closest('[data-order-remove]')) {
          event.preventDefault();
          this.openConfirm();
          return;
        }

        if (target.closest('[data-order-cancel]')) {
          this.querySelector('[data-order-confirm]')?.close();
          return;
        }

        if (target.closest('[data-order-confirm-submit]')) {
          this.querySelector('[data-order-confirm]')?.close();
          this.removeAll();
        }
      }

      onInput(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches('[data-order-qty]')) return;
        const row = input.closest('[data-variant-id]');
        if (!(row instanceof HTMLElement)) return;
        this.paintRow(row);
        this.paintFooter();
      }

      onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches('[data-order-qty]')) return;
        const row = input.closest('[data-variant-id]');
        if (!(row instanceof HTMLElement) || row.dataset.available === 'false') return;
        const next = this.clamp(input, Number.parseInt(input.value, 10));
        input.value = String(next);
        this.commit(row, next);
      }

      openConfirm() {
        const dialog = this.querySelector('[data-order-confirm]');
        const text = this.querySelector('[data-order-confirm-text]');
        if (!(dialog instanceof HTMLDialogElement) || !text) return;
        const count = this.unitCount();
        if (count < 1) return;
        text.textContent = count === 1
          ? this.config.removeOne || ''
          : String(this.config.removeOther || '').replace('__COUNT__', String(count));
        dialog.showModal();
      }

      removeAll() {
        for (const row of this.querySelectorAll('[data-variant-id]')) {
          if (!(row instanceof HTMLElement)) continue;
          const input = row.querySelector('[data-order-qty]');
          if (input instanceof HTMLInputElement) input.value = '0';
          this.pending.set(row.dataset.variantId, 0);
          this.paintRow(row);
        }
        this.paintFooter();
        this.flush();
      }

      commit(row, qty) {
        this.pending.set(row.dataset.variantId, qty);
        this.paintRow(row);
        this.paintFooter();
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.flush(), 280);
      }

      clamp(input, qty) {
        let next = qty;
        if (!Number.isFinite(next) || next < 0) next = 0;
        if (input.max !== '' && next > Number(input.max)) next = Number(input.max);
        return next;
      }

      unitCount() {
        let units = 0;
        for (const row of this.querySelectorAll('[data-variant-id]')) {
          if (!(row instanceof HTMLElement)) continue;
          units += this.qtyFrom(row);
        }
        return units;
      }

      qtyFrom(row) {
        const input = row.querySelector('[data-order-qty]');
        const qty = input instanceof HTMLInputElement ? Number.parseInt(input.value, 10) : 0;
        return Number.isFinite(qty) && qty > 0 ? qty : 0;
      }

      paintRow(row) {
        const total = row.querySelector('[data-line-total]');
        if (!total) return;
        const qty = this.qtyFrom(row);
        total.textContent = this.formatMoney(qty * (Number(row.dataset.price) || 0));
      }

      paintFooter() {
        let units = 0;
        let subtotal = 0;
        for (const row of this.querySelectorAll('[data-variant-id]')) {
          if (!(row instanceof HTMLElement)) continue;
          const qty = this.qtyFrom(row);
          units += qty;
          subtotal += qty * (Number(row.dataset.price) || 0);
        }
        const unitsEl = this.querySelector('[data-order-units]');
        const subtotalEl = this.querySelector('[data-order-subtotal]');
        if (unitsEl) unitsEl.textContent = String(units);
        if (subtotalEl) subtotalEl.textContent = this.formatMoney(subtotal);
        const remove = this.querySelector('[data-order-remove]');
        if (remove instanceof HTMLButtonElement) remove.disabled = units === 0;
      }

      applyCart(cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        const quantities = new Map();
        for (const item of cart.items) {
          if (String(item.product_id) !== this.dataset.productId) continue;
          const id = String(item.variant_id);
          quantities.set(id, (quantities.get(id) || 0) + item.quantity);
        }

        for (const row of this.querySelectorAll('[data-variant-id]')) {
          if (!(row instanceof HTMLElement)) continue;
          if (this.pending.has(row.dataset.variantId)) continue;
          const input = row.querySelector('[data-order-qty]');
          if (!(input instanceof HTMLInputElement) || document.activeElement === input) continue;
          input.value = String(quantities.get(row.dataset.variantId) || 0);
          this.paintRow(row);
        }

        this.paintFooter();
      }

      async flush() {
        if (this.flushing) {
          this.queued = true;
          return;
        }
        if (!this.pending.size) return;

        const updates = Object.fromEntries(this.pending);
        this.pending.clear();
        this.flushing = true;
        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(this.jsonEndpoint(this.config.updateUrl), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            this.showError(this.errorText(data));
            const cart = await this.readCart();
            document.dispatchEvent(new CustomEvent('theme:cart-apply', { detail: cart }));
            return;
          }
          this.showError('');
          document.dispatchEvent(new CustomEvent('theme:cart-apply', { detail: data }));
        } catch (error) {
          this.showError(this.config.error || '');
        } finally {
          this.flushing = false;
          this.setAttribute('aria-busy', 'false');
          if (this.queued || this.pending.size) {
            this.queued = false;
            this.flush();
          }
        }
      }

      async readCart() {
        const response = await fetch(this.jsonEndpoint(this.config.cartUrl), {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(this.config.error || '');
        return response.json();
      }

      errorText(data) {
        if (!data) return this.config.error || '';
        if (typeof data.description === 'string' && data.description) return data.description;
        if (typeof data.message === 'string' && data.message) return data.message;
        if (typeof data.errors === 'string' && data.errors) return data.errors;
        return this.config.error || '';
      }

      showError(message) {
        const el = this.querySelector('[data-order-error]');
        if (!el) return;
        el.hidden = !message;
        el.textContent = message || '';
      }

      jsonEndpoint(url) {
        const value = String(url || '');
        return value.endsWith('.js') ? value : `${value}.js`;
      }

      formatMoney(cents) {
        const open = '{';
        const format = this.config.moneyFormat || `$${open}{amount}}`;
        const placeholder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
        const token = (format.match(placeholder) || [])[1];
        let value = '';

        const withDelimiters = (number, precision, thousands, decimal) => {
          const fixed = (number / 100).toFixed(precision);
          const parts = fixed.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
          return dollars + (parts[1] ? decimal + parts[1] : '');
        };

        switch (token) {
          case 'amount_no_decimals':
            value = withDelimiters(cents, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = withDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = withDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = withDelimiters(cents, 2, "'", '.');
            break;
          default:
            value = withDelimiters(cents, 2, ',', '.');
        }

        return format.replace(placeholder, value);
      }
    }

    customElements.define('product-order', ProductOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-product-carousel')) {
    class RelatedProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        const url = this.dataset.url;
        if (!url) return;

        const load = () => {
          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const carousel = documentFragment.querySelector('[data-related-carousel]');
              const designMode = window.Shopify && window.Shopify.designMode;

              if (!carousel) {
                if (!designMode) {
                  const section = this.closest('.shopify-section');
                  if (section) section.remove();
                  else this.remove();
                }
                return;
              }

              this.replaceWith(carousel);

              if (!carousel.querySelector('[data-swiper]')) return;

              let frames = 0;
              const scan = () => {
                if (typeof window.Swiper === 'function') {
                  carousel.dispatchEvent(new CustomEvent('theme:swiper:scan', { bubbles: true }));
                  return;
                }

                frames += 1;
                if (frames < 240) window.requestAnimationFrame(scan);
              };

              scan();
            })
            .catch(() => {
              const designMode = window.Shopify && window.Shopify.designMode;
              if (!designMode) {
                const section = this.closest('.shopify-section');
                if (section) section.remove();
                else this.remove();
              }
            });
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            load();
          }, { rootMargin: '0px 0px 200px 0px' });
          observer.observe(this);
        } else {
          load();
        }
      }
    }

    customElements.define('related-product-carousel', RelatedProductCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
